import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=5142a34b&scoped=true&"
import script from "./AppProfile.vue?vue&type=script&lang=js&"
export * from "./AppProfile.vue?vue&type=script&lang=js&"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=5142a34b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142a34b",
  null
  
)

export default component.exports